<template>
  <tr>
    <td :colspan="colspan">
      <v-row

        class="justify-end align-center py-2"
      >
        <v-pagination
          v-if="lastPage > 1"
          v-model="pageDirty"
          :total-visible="totalVisible"
          :length="lastPage"
        />
      </v-row>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'TableFooter',
    props: {
      lastPage: {
        type: Number,
        default: 1
      },
      page: {
        type: Number,
        default: 1
      },
      totalVisible: {
        type: Number,
        default: 10
      },
      colspan: {
        type: [Number, String],
        default: 8
      }
    },
    computed: {
      pageDirty: {
        get: function () {
          return this.page
        },
        set: function (val) {
          this.$emit('update:page', val)
        }
      }
    }
  }
</script>
